import DropdownButton from "../../Components/Form/DropdownButton";

/**
 * Products can be listed in all shops but only salable in another shop location.
 * For this reason, a button to get to the selling partner shop is displayed.
 * In case of multiple locations the url of this button needs to change dynamically.
 */
class LocationDropdownButton {
    private dropdownButton: DropdownButton;

    /**
     * Init a new instance of a location dropdown button on pdp
     */
    constructor(dropdownButton: DropdownButton) {
        this.dropdownButton = dropdownButton;
        this.initEventListener();
    }

    private initEventListener(): void {
        this.dropdownButton.addEventListener("change", this.handleChange);
    }

    private handleChange(event: Event): void {
        // @ts-ignore
        const locationUrl = event.target.options[event.target.selectedIndex].dataset.locationUrl;
        document.querySelector("a.location-redirect").setAttribute("href", locationUrl);
    }
}

document.querySelectorAll("x-dropdown-button.location").forEach((dropdownButton: DropdownButton) => {
    new LocationDropdownButton(dropdownButton);
});
